













































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FbaseClientService, FbaseClient } from '@/services/FbaseClientService';
import { DataTableHeader } from 'vuetify';
import { KSpinner, KSelect, KSwitch, KText, }   from '@kasasa/fbase-components';
import { Alert, NoticeClass, NoticeResponse, Dialog } from '@kasasa/fbase-components/lib';

const reverseSort = (a: number, b: number): number => (a > b ? -1 : 1);


@Component({
	components: {
		KSpinner,
		KSelect,
		KSwitch,
		KText,
	},
}) 
export default class ClientListTable extends Vue {
	@Prop({ default: false })    readonly canWrite!:  boolean;
	@Prop({ default: false })    readonly canDelete!: boolean;

	headers: DataTableHeader[] = [
		{ text: 'FI ID',         value: 'fiId',    width: '115px' },
		{ text: 'Client Name',   value: 'name',    width: '500px' },
		{ text: 'Client Status', value: 'enabled', width: '120px', sort: reverseSort }, // reverse sort so 1 (Active) is ascending
		{ text: '',              value: 'actions', width: '110px', sortable: false, align: 'end' }
	];

	fbaseSvc = new FbaseClientService(this.$store);
	allClients: FbaseClient[] = [];
	isDataLoaded = false;

	search    = '';
	useFilter = false;
	filterStatus = {
		All:      'All',
		Active:   'Active',
		Inactive: 'Inactive'
	};
	currentFilterStatus = this.filterStatus.Active;


	created(): void {
		this.fbaseSvc.getClients({})
			.then(resp => {
				this.allClients = resp.data.data;
				this.isDataLoaded = true;
			})
			.catch(() => {
				// no errors besides 401, 403 and 500 to listen for.
			});
	}

	get displayClients(): FbaseClient[] {
		let filteredClients = this.allClients;

		if (this.useFilter) {
			if (this.currentFilterStatus !== this.filterStatus.All) {
				const enabled = Number(this.currentFilterStatus === this.filterStatus.Active);
				filteredClients = filteredClients.filter((client) => client.enabled == enabled);
			}

		} else { // Default view only shows enabled clients
			filteredClients = filteredClients
				.sort((a, b) => a.name.localeCompare(b.name))
				.filter((client) => client.enabled);
		}

		return filteredClients;
	}

	resetFilter(): void {
		this.currentFilterStatus = this.filterStatus.All;
	}
	
	customFilter(index: number, searchParam: string, client: FbaseClient): boolean {
		const search = searchParam.toLowerCase();
		return client.id.toString().toLowerCase().indexOf(search) !== -1
			|| (client.fiId !== null && client.fiId.toString().toLowerCase().indexOf(search) !== -1)
			|| client.name.toLowerCase().indexOf(search) !== -1;
	}

	searchHighlight(value: string|number): string|number {
		if (!this.search.length || value === null) {
			return value;
		}

		return value.toString().replace(
			RegExp(this.search, 'ig'),
			(matchText) => '<strong style="color: #000;">' + matchText + '</strong>'
		);
	}

	async deleteClient(item: FbaseClient): Promise<void> {
		const dialog = new Dialog('Delete this client?', `Are you sure you want to delete "${item.name}"? This cannot be undone.`, 'DELETE');
		dialog.setDeclineLabel('CANCEL')
			.setDismissable(false);
		const res = await this.$store.dispatch('notices/add', dialog);
		switch (res) {
			case NoticeResponse.ACCEPT: 
				this.fbaseSvc.deleteClient(item.id)
					.then(() => {
						this.allClients.splice(this.allClients.indexOf(item), 1);
						const success = new Alert(`Client "${item.name}" is deleted. `, NoticeClass.SUCCESS);
						success.setTimeout(6000);
						this.$store.dispatch('notices/add', success);
					})
					.catch(() => {
						const fail = new Alert(`There was a problem deleting client "${item.name}". `, NoticeClass.ERROR);
						fail.setTimeout(3000);
						this.$store.dispatch('notices/add', fail);
					});
				break;	
			case NoticeResponse.DECLINE: 
			default:
				// do nothing		
		}
	}
}
